import { DataHolderService } from './../../../../services/data-holder.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {

  constructor(public dataHolderService : DataHolderService) { }

  ngOnInit() {
  }

}
